
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";

@Component({name:"hi-poptip"})
export default class HiPoptip extends Vue {
  @Prop({ type: String, default: "" }) title: string;
  @Prop({ type: String, default: "" }) okText: string;
  @Prop({ type: String, default: "" }) cancelText: string;

  visible: boolean = false;
  created() {}

  ok() {
    this.$emit("on-ok");
  }

  cancel() {
    this.$emit("on-cancel");
  }

  popperHide() {
    this.visible = false;
  }

  popperShow() {
    this.visible = true;
  }
}
